import { render, staticRenderFns } from "./DemoContact.vue?vue&type=template&id=6c9fc74c&"
import script from "./DemoContact.vue?vue&type=script&lang=js&"
export * from "./DemoContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports